import { render, staticRenderFns } from "./sendemail.vue?vue&type=template&id=ae71904e&"
import script from "./sendemail.vue?vue&type=script&lang=js&"
export * from "./sendemail.vue?vue&type=script&lang=js&"
import style0 from "./sendemail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports